import { getCsrfToken } from './get_csrf_token';

export const CONTINUE_DISABLED_DOCUMENT_KINDS = ['illness_script', 'student_resource'];

/** Design-system two-column case: Continue uses unlock endpoint + Turbo Streams (not inline onClick KV). */
export const railsStudentCaseUnlockContinue = () => {
  const el = document.getElementById('document-container');
  if (!el) return false;
  const documentKind = el.getAttribute('data-case-experience--case-viewer-document-kind-value');
  if (CONTINUE_DISABLED_DOCUMENT_KINDS.includes(documentKind)) return false;
  if (el.getAttribute('data-case-experience--case-viewer-is-student-value') === 'true') return true;
  return !!document.getElementById('case-experience-active-pane');
};

export const caseExperienceApplyStateUrl = (documentId) =>
  `/documents/${documentId}/case_experience/apply_state`;

export const caseExperiencePatchStateUrl = (documentId) =>
  `/documents/${documentId}/case_experience/patch_state`;

export const caseExperienceSubmitAnswerUrl = (documentId) =>
  `/documents/${documentId}/case_experience/submit_answer`;

export const caseExperienceUnlockUrl = (documentId) =>
  `/documents/${documentId}/case_experience/unlock_next_section`;

export const caseExperienceSwitchSectionUrl = (documentId) =>
  `/documents/${documentId}/case_experience/switch_section.turbo_stream`;

export const caseExperienceSwitchAdminViewUrl = (documentId) =>
  `/documents/${documentId}/case_experience/switch_admin_view.turbo_stream`;

export const caseExperienceLogEventUrl = (documentId) =>
  `/documents/${documentId}/case_experience/log_event`;

export function getCaseExperienceAdminPreviewMode() {
  const preview = document.querySelector("[data-case-experience--case-preview-admin-preview-mode-value]");
  if (!preview) return null;

  return preview.getAttribute("data-case-experience--case-preview-admin-preview-mode-value") || "ungated";
}

function activePaneRootSectionUid() {
  const pane = document.getElementById('case-experience-active-pane');
  if (!pane) return null;

  const section =
    pane.querySelector('[data-case-experience--case-viewer-target="section"]') ||
    pane.querySelector('.doc-section[data-level="1"]');
  const uid = section?.dataset?.uid;
  return uid || null;
}

export function withCaseExperienceAdminPreviewMode(body) {
  const adminPreviewMode = getCaseExperienceAdminPreviewMode();
  if (!adminPreviewMode) return body;

  const enriched = { ...body, admin_preview_mode: adminPreviewMode };
  if (adminPreviewMode === 'ungated') {
    const currentSectionUid = activePaneRootSectionUid();
    if (currentSectionUid) {
      enriched.current_section_uid = currentSectionUid;
    }
  }
  return enriched;
}

export async function postCaseExperienceLogEvent(documentId, logType, extra = {}) {
  const res = await fetch(caseExperienceLogEventUrl(documentId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({
      type: logType,
      node_uid: extra.node_uid,
      document_set_id: extra.document_set_id,
    }),
  });
  let parsed = null;
  try {
    if (res.ok) parsed = await res.json();
  } catch {
    parsed = null;
  }
  return parsed;
}
